export type AppErrorCode =
  | 'VALIDATION_ERROR'
  | 'AUTH_REQUIRED'
  | 'PERMISSION_DENIED'
  | 'MFA_REQUIRED'
  | 'NOT_FOUND'
  | 'CONFLICT'
  | 'NETWORK_ERROR'
  | 'CONFIGURATION_ERROR'
  | 'SERVER_ERROR'

export class AppError extends Error {
  constructor(
    public readonly code: AppErrorCode,
    message: string,
    public readonly field?: string,
    public readonly cause?: unknown,
  ) {
    super(message)
    this.name = 'AppError'
  }
}

type ErrorLike = { message?: string; code?: string; status?: number }

export function normalizeError(error: unknown): AppError {
  if (error instanceof AppError) return error
  const candidate = (error ?? {}) as ErrorLike
  if (candidate.status === 401)
    return new AppError('AUTH_REQUIRED', 'Sila log masuk semula.', undefined, error)
  if (candidate.status === 403 || candidate.code === '42501') {
    if (/dua faktor/i.test(candidate.message ?? '')) {
      return new AppError(
        'MFA_REQUIRED',
        'Pengesahan dua faktor diperlukan untuk tindakan ini.',
        undefined,
        error,
      )
    }
    return new AppError(
      'PERMISSION_DENIED',
      'Anda tidak mempunyai kebenaran untuk tindakan ini.',
      undefined,
      error,
    )
  }
  if (candidate.status === 404 || candidate.code === 'PGRST116') {
    return new AppError('NOT_FOUND', 'Rekod yang diminta tidak ditemui.', undefined, error)
  }
  if (/already registered|already exists|duplicate/i.test(candidate.message ?? '')) {
    return new AppError(
      'VALIDATION_ERROR',
      'E-mel ini telah didaftarkan. Log masuk atau gunakan pemulihan kata laluan.',
      'email',
      error,
    )
  }
  if (
    candidate.status === 409 ||
    candidate.code === 'P0001' ||
    candidate.code === 'SAMBEST_CONFLICT'
  ) {
    return new AppError(
      'CONFLICT',
      'Rekod ini telah berubah. Muat semula dan cuba lagi.',
      undefined,
      error,
    )
  }
  if (/fetch|network|failed to connect/i.test(candidate.message ?? '')) {
    return new AppError(
      'NETWORK_ERROR',
      'Sambungan terganggu. Semak rangkaian dan cuba lagi.',
      undefined,
      error,
    )
  }
  return new AppError(
    'SERVER_ERROR',
    'Sesuatu tidak berjalan seperti dijangka. Sila cuba lagi.',
    undefined,
    error,
  )
}
